import { CalendarDays, CalendarClock, CalendarOff, Car, MessageCircle, Receipt, PencilRuler, Sun, Users, type LucideIcon } from 'lucide-react';
import type { Section } from '../../store/ui';

// Navigation de l'application moniteur (refonte du 14/10/2026) : mêmes rubriques qu'avant, libellés courts.
// « Équipe » retirée le 21/10/2026 : une note, une réunion ou un tableau s'ouvre seulement depuis un message.
// Tablette et ordinateur : colonne à gauche ; téléphone : barre du bas (4 entrées + « Plus »).

export interface NavItem {
  id: Section;
  label: string;
  /** Titre complet (infobulle de la colonne étroite, lecteurs d'écran). */
  title: string;
  icon: LucideIcon;
}

export const NAV: NavItem[] = [
  { id: 'jour', label: 'Journée', title: 'Ma journée', icon: Sun },
  { id: 'planning', label: 'Planning', title: 'Mon planning', icon: CalendarDays },
  { id: 'eleves', label: 'Élèves', title: 'Mes élèves', icon: Users },
  { id: 'previsions', label: 'Prévisions', title: "Prévisions d'examen", icon: CalendarClock },
  { id: 'absences', label: 'Absences', title: 'Congés et absences', icon: CalendarOff },
  // Dégâts des véhicules de l'école (24/10/2026) : signalement avec photos, état connu de chaque véhicule. Pour une
  // école qui gère ses véhicules dans Permio (voir `Layout`).
  { id: 'vehicules', label: 'Véhicules', title: 'Véhicules et dégâts', icon: Car },
  // Pour tout moniteur à la fiche active (voir `Layout`).
  { id: 'factures', label: 'Factures', title: 'Mes factures', icon: Receipt },
  { id: 'tableau', label: 'Tableau', title: 'Tableau', icon: PencilRuler },
  { id: 'messages', label: 'Messages', title: 'Messages', icon: MessageCircle },
  // « Signaler un problème » n'est pas dans la navigation : seulement dans le menu du compte (en haut).
];

/** Barre du bas (téléphone) : quatre entrées, le reste dans « Plus ». */
const BOTTOM: Section[] = ['jour', 'planning', 'eleves', 'messages'];

export function bottomTabs(items: NavItem[]): { main: NavItem[]; more: NavItem[] } {
  return {
    main: BOTTOM.map((id) => items.find((i) => i.id === id)).filter((i): i is NavItem => !!i),
    more: items.filter((i) => !BOTTOM.includes(i.id)),
  };
}

/** Pastille de non-lus (« 99+ » au-delà), avec le nombre lu par les lecteurs d'écran. */
export function unreadLabel(count: number) {
  return ` : ${count} non lu${count > 1 ? 's' : ''}`;
}
